<template>
  <div v-if="isComponentVisible" class="h-100">
    <!-- Display video stream for capturing photo -->
    <div v-if="isCameraOpen && !photo" class="video-container">
      <video ref="video" class="responsive-video" autoplay playsinline height="100%"></video>
      <div class="button-take-photo">
        <b-button @click="takePicture" variant="primary" class="capture-button">
        </b-button>
      </div>
      <canvas ref="canvas" style="display: none"></canvas>
    </div>

    <!-- Display captured photo and options to save or retake -->
    <div v-else-if="photo" class="photo-container">
      <img :src="photo" alt="captured photo" class="responsive-image" />
      <div class="button-container">
        <div class="d-flex justify-content-between align-items-center px-4">
          <div class="pr-3 cursor-pointer button-reload" @click="retakePicture">
            <b-icon icon="arrow-clockwise" font-scale="1.5"></b-icon>
          </div>

          <b-button @click="savePicture" class="button-send px-3">
            <i class="ni ni-send text-primary"></i>
          </b-button>
        </div>
      </div>
    </div>

    <!-- Display error message if any -->
    <div v-if="errorMessage" style="color: red">{{ errorMessage }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isComponentVisible: false,
      isCameraOpen: false,
      photo: null,
      errorMessage: null,
    };
  },
  methods: {
    // Open the camera with the specified facing mode
    async openCamera(facingMode) {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        try {
          this.isCameraOpen = true;
          const stream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: facingMode },
            audio: false,
          });
          this.$refs.video.srcObject = stream;
          this.$emit("camera-opened");
        } catch (err) {
          console.error("Error accessing camera: ", err);
          this.errorMessage = "Error accessing camera: " + err.message;
          this.isCameraOpen = false;
        }
      } else {
        this.errorMessage =
          "Your browser does not support access to the camera.";
      }
    },
    // Capture photo from the video stream
    takePicture() {
      const video = this.$refs.video;
      const canvas = this.$refs.canvas;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const context = canvas.getContext("2d");
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      this.photo = canvas.toDataURL("image/png");
      this.$emit("picture-taken", this.photo);
      this.closeCameraStream();
    },
    dataURLtoBlob(dataurl) {
      const arr = dataurl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    // Emit event to save the photo
    savePicture() {
      const blob = this.dataURLtoBlob(this.photo);
      const file = new File([blob], "photo.png", { type: "image/png" });
      this.$emit("save-picture", file);
    },
    // Retake the photo by reopening the camera
    retakePicture() {
      this.photo = null;
      this.openCamera("user"); // Can be 'environment' as needed
    },
    // Close the video stream
    closeCameraStream() {
      const stream = this.$refs.video ? this.$refs.video.srcObject : null;
      if (stream) {
        const tracks = stream.getTracks();
        tracks.forEach((track) => track.stop());
      }
      this.isCameraOpen = false;
    },
    // Close the camera and emit event
    closeCamera() {
      this.closeCameraStream();
    },
    // Reset component state
    resetComponent() {
      this.isComponentVisible = false;
      this.isCameraOpen = false;
      this.photo = null;
      this.errorMessage = null;
    },
    // Toggle component visibility and handle camera state
    toggleComponentVisibility() {
      if (this.isComponentVisible) {
        this.closeCamera();
        this.resetComponent();
      } else {
        this.isComponentVisible = true;
        this.openCamera("user");
      }
    },
  },
};
</script>

<style>
.video-container {
  position: relative;
  width: 100%;
  height: 100vh;
}

.responsive-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.capture-button {
  text-align: center;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  border: 5px solid white;
}

.capture-button {
  display: block;
  margin: 10px auto;
}

.photo-container {
  height: 100%;
}

.button-reload{
  color: white;
}

.button-send {
  border-radius: 50%;
}

.button-send i {
  font-size: 140%;
}


.button-container {
  position: absolute;
  bottom: 50px;
  width: 100%;
}

.responsive-image {
  width: 100%;
  height: 100vh;
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
}

.button-take-photo{
  position: absolute;
  bottom: 10vh;
  right: 50%;
  transform: translate(50%, 50%);
}

@media (max-width: 600px) {
  .button-take-photo {
    bottom: 17vh;
    right: 50%;
    transform: translate(50%, 50%);
  }


  .button-container {
    position: absolute;
    bottom: 17vh;
    width: 100%;
  }
}

</style>
